import { render, staticRenderFns } from "./BineAiVenit.vue?vue&type=template&id=1ab3b745&scoped=true&"
import script from "./BineAiVenit.ts?vue&type=script&lang=ts&"
export * from "./BineAiVenit.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab3b745",
  null
  
)

export default component.exports